/* import __COLOCATED_TEMPLATE__ from './market-help-link.hbs'; */
import { notEmpty, reads } from '@ember/object/computed';
import { computed } from '@ember/object';
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { getLocalePath } from '@dashboard/junk-drawer/utils/i18n-link';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  dataApi: service(),
  userInfo: service(),
  eventName: null,
  articleId: null,
  articleSection: null,
  tagName: 'market-link',
  attributeBindings: ['href', 'target'],
  target: '_blank',
  linkText: null,
  hasLinkText: notEmpty('linkText'),
  showRightCaret: reads('hasLinkText'),
  utmParams: computed(function () {
    return {
      utmSource: 'dashboard',
      utmMedium: 'web'
    };
  }),
  href: computed('articleId', 'articleSection', 'utmParams.{utmContent,utmSource,utmMedium,utmCampaign}', 'userInfo.{countryCode,languageCode}', function () {
    const localePath = getLocalePath(this.userInfo?.countryCode, this.userInfo?.languageCode);
    let url = `//squareup.com/help/${localePath}article/${this.articleId}`;
    const params = [];
    if (this.utmParams.utmContent) {
      params.push(`utm_content=${this.utmParams.utmContent}`);
    }
    if (this.utmParams.utmSource) {
      params.push(`utm_source=${this.utmParams.utmSource}`);
    }
    if (this.utmParams.utmMedium) {
      params.push(`utm_medium=${this.utmParams.utmMedium}`);
    }
    if (this.utmParams.utmCampaign) {
      params.push(`utm_campaign=${this.utmParams.utmCampaign}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    if (this.articleSection) {
      url += `#${this.articleSection}`;
    }
    return url;
  }),
  click() {
    if (this.eventName) {
      this.dataApi.track(this.eventName);
    }
  }
});